<template>
  <div>
    <!-- <div v-if="isLoading" class="homeUserPreloader">
      <div class="preloaderLoader"></div>
    </div> -->
    <div
      class="SliderShowToUSerImage SliderShowToUSerImageBG"
      :class="{ noStory: usersStory.length == 0 }"
    >
      <story-slide-wrapper></story-slide-wrapper>

      <div v-if="LoadingSkeleton" class="SnappCarousel mobileSnapCaouselSlider">
        <Skeletor
          style="
            background: rgb(146, 221, 238);
            display: block;
            width: 95%;
            height: 150px;
            border-radius: 10px;
            margin: 0 auto;
          "
        />
      </div>

      <Swiper
        v-if="pageWidth <= 1000 && !LoadingSkeleton"
        class="SnappCarousel"
        :slides-per-view="1"
        ref="bannerSwiper"
        :loop="true"
        :modules="modules"
        :observer="true"
        :observe-parents="true"
        :autoplay="{
          delay: 4000,
          disableOnInteraction: false,
        }"
        :pagination="{
          dynamicBullets: true,
        }"
      >
        <SwiperSlide
          @click="open_banner(v.link)"
          v-for="(v, i) in $store.state.c_set.amlak_banner_slider_items"
          :key="i"
        >
          <img class="SowToUserBoxesSnapp" :src="v.img" alt="banner" />
        </SwiperSlide>

        <template v-slot:addons>
          <pagination />
        </template>
      </Swiper>

      <div style="text-align: center; display: flex; flex-direction: column">
        <Skeletor
          v-if="LoadingSkeleton"
          style="
            margin: auto;
            height: 45px;
            background: #92ddeeff;
            margin-top: 72px;
          "
          class="AllFilterbutton_wrapper searhbarTitleSkeletor"
        />
        <Skeletor
          v-if="LoadingSkeleton"
          style="
            margin: auto;
            height: 50px;
            border-radius: 24px;
            background: #92ddeeff;
            margin-top: 50px;
          "
          class="AllFilterbutton_wrapper searchBarSkeletor"
        />
      </div>

      <filter-home v-if="!LoadingSkeleton"></filter-home>
      <div
        v-if="LoadingSkeleton"
        style="margin-top: 50px"
        class="ShowTitleSiteTemplate categoryTitleSkeletor"
      >
        <Skeletor
          style="
            width: 42px !important;
            background: rgb(146, 221, 238);
            height: 42px;
            border-radius: 50%;
          "
        />
        <Skeletor
          style="
            width: 292px !important;
            background: rgb(146, 221, 238);
            height: 42px;
            border-radius: 24px;
          "
        />
      </div>
      <div>
        <div
          v-if="LoadingSkeleton"
          style="justify-content: space-between !important; margin: auto"
          class="ShowTabToUserCustomer1 categoryListSkeletor"
        >
          <div
            style="
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
            "
            class="ShowHomeWidthAdnIcon"
            v-for="index in 8"
            :key="index"
          >
            <Skeletor
              style="
                width: 90% !important;
                background: rgb(146, 221, 238);
                border-radius: 5px;
              "
              class="ChildShowTabToUserCustomer"
            />
          </div>
        </div>
        <div
          class="homeCategoryTitleWrapper titleSkeletor"
          v-if="LoadingSkeleton"
        >
          <Skeletor
            style="
              width: 42px !important;
              background: rgb(146, 221, 238);
              height: 42px;
              border-radius: 50%;
            "
          />
          <Skeletor
            style="
              width: 292px !important;
              background: rgb(146, 221, 238);
              height: 42px;
              border-radius: 24px;
            "
          />
        </div>
        <div class="homeCategoryTitleWrapper" v-if="!LoadingSkeleton">
          <div class="titleIcon">
            <VsxIcon
              iconName="Category"
              :size="28"
              color="#0096c7"
              type="linear"
            />
          </div>
          <div class="categoryTitle">دسته بندی</div>
        </div>
        <div
          v-if="!LoadingSkeleton"
          class="ShowTabToUserCustomer1 categoryList"
        >
          <div
            class="ShowHomeWidthAdnIcon"
            v-for="(melk, index) in category_list"
            :key="index"
          >
            <div
              @click="open_category(melk.key)"
              class="ChildShowTabToUserCustomer"
            >
              <img :src="melk.img" :alt="melk.value" />
              <p>{{ melk.value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- فایل های ویژه -->
    <div class="mobileMain">
      <div v-if="LoadingSkeleton" class="ShowTabToUserCustomer">
        <Swiper
          v-if="LoadingSkeleton"
          :slides-per-view="showItemNum"
          class="featuresCarousel"
        >
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div
        v-if="!LoadingSkeleton"
        style="margin-top: 50px"
        class="ShowTitleSiteTemplate adsTitle"
      >
        <VsxIcon
          iconName="NotificationBing"
          :size="32"
          color="#0096c7 "
          type="linear"
        />
        <p>آگهی‌های ویژه</p>
      </div>
      <div v-if="!LoadingSkeleton" class="ShowTabToUserCustomer">
        <Swiper
          v-if="!LoadingSkeleton"
          :slides-per-view="showItemNum"
          class="featuresCarousel"
        >
          <SwiperSlide>
            <div
              @click="open_category2('request')"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/document.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">متقاضی</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              @click="open_category2('fast')"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/lightning-bolt.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">
                  آگهی‌های فوری
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              @click="open_category2('exchangeable')"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/replace(1).png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">معاوضه</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              @click="open_category2('student')"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/student.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">
                  دانشجو / مجرد
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <!-- فایل های ویژه -->
      <!-- امکانات ویژه -->
      <div v-if="LoadingSkeleton" class="ShowTitleSiteTemplate titleMt50">
        <Skeletor
          style="
            width: 42px !important;
            background: rgb(146, 221, 238);
            height: 42px;
            border-radius: 50%;
          "
        />
        <Skeletor
          style="
            width: 292px !important;
            background: rgb(146, 221, 238);
            height: 42px;
            border-radius: 24px;
          "
        />
      </div>
      <div
        v-if="LoadingSkeleton"
        class="mobileFeatures ShowTabToUserCustomer featuresShowTab"
      >
        <div class="featuresCarousel featuresCarouselFlex">
          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 10px;
                "
              />
              <p
                class="featuresTitle featuresTitleResponsive"
                style="min-height: 28px"
              ></p>
            </div>
          </div>

          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 10px;
                "
              />
              <p
                class="featuresTitle featuresTitleResponsive"
                style="min-height: 28px"
              ></p>
            </div>
          </div>

          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 10px;
                "
              />
              <p
                class="featuresTitle featuresTitleResponsive"
                style="min-height: 28px"
              ></p>
            </div>
          </div>

          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 10px;
                "
              />
              <p
                class="featuresTitle featuresTitleResponsive"
                style="min-height: 28px"
              ></p>
            </div>
          </div>

          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 10px;
                "
              />
              <p
                class="featuresTitle featuresTitleResponsive"
                style="min-height: 28px"
              ></p>
            </div>
          </div>

          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  aspect-ratio: 1;
                  border-radius: 10px;
                "
              />
              <p
                class="featuresTitle featuresTitleResponsive"
                style="min-height: 28px"
              ></p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="LoadingSkeleton" class="desktopFeatures ShowTabToUserCustomer">
        <Swiper
          v-if="LoadingSkeleton"
          :slides-per-view="showItemNum"
          class="featuresCarousel"
        >
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="ChildShowTabToUserCustomer1 sliderBottm">
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
                <p
                  class="featuresTitle featuresTitleResponsive"
                  style="min-height: 28px"
                ></p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div v-if="!LoadingSkeleton" class="ShowTitleSiteTemplate titleMt50">
        <VsxIcon iconName="Layer" :size="32" color="#0096c7 " type="linear" />
        <p>خدمات هوشمند</p>
      </div>
      <div
        v-if="!LoadingSkeleton"
        class="mobileFeatures ShowTabToUserCustomer featuresShowTab"
      >
        <div class="featuresCarousel featuresCarouselFlex">
          <div
            class="ChildShowTabToUserCustomer1 sliderBottm"
            @click="featureRouteHandler('commission')"
          >
            <div style="width: 95%; margin: auto">
              <div class="featuresImageWrapper">
                <img
                  class="featuresThumbImage"
                  src="../assets/img/budget.png"
                />
              </div>
              <p class="featuresTitle featuresTitleResponsive">
                محاسبه کمیسیون
              </p>
            </div>
          </div>

          <a
            href="https://www.kateb.ir/"
            target="_blank"
            class="ChildShowTabToUserCustomer1 sliderBottm"
          >
            <div style="width: 95%; margin: auto">
              <div class="featuresImageWrapper">
                <img
                  class="featuresThumbImage"
                  src="../assets/img/auction1.png"
                />
              </div>
              <p class="featuresTitle featuresTitleResponsive">
                سامانه کاتب
              </p>
            </div>
          </a>

          <a
            href="https://khodnevis.mrud.ir/"
            target="_blank"
            class="ChildShowTabToUserCustomer1 sliderBottm"
          >
            <div style="width: 95%; margin: auto">
              <div class="featuresImageWrapper">
                <img
                  class="featuresThumbImage"
                  src="../assets/img/enterprise1.png"
                />
              </div>
              <p class="featuresTitle featuresTitleResponsive">
                سامانه خودنویس
              </p>
            </div>
          </a>

          <div
            @click="top_users('all')"
            class="ChildShowTabToUserCustomer1 sliderBottm"
          >
            <div style="width: 95%; margin: auto">
              <div class="featuresImageWrapper">
                <img
                  class="featuresThumbImage"
                  src="../assets/img/trophy.png"
                />
              </div>
              <p class="featuresTitle featuresTitleResponsive">امتیاز برتر</p>
            </div>
          </div>
          <div
            class="ChildShowTabToUserCustomer1 sliderBottm"
            v-for="(v, i) in $store.state.c_set.amlak_article_cat"
            :key="i"
            @click="changeRouteHandler(v.id, v.title)"
          >
            <div style="width: 95%; margin: auto">
              <div class="featuresImageWrapper">
                <img class="featuresThumbImage" :src="v.icon" />
              </div>
              <p class="featuresTitle featuresTitleResponsive">{{ v.title }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          !LoadingSkeleton &&
          $store.state.c_set &&
          $store.state.c_set.shomal_banner_items &&
          $store.state.c_set.shomal_banner_items.length
        "
        class="ShowTitleSiteTemplate titleMt50"
      >
        <svg
          style="width: 32px; height: 32px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#0096c7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="star-icon"
        >
          <path
            d="M12 2L14.5 8.5L21.5 9.5L16 14L17.5 21L12 17L6.5 21L8 14L2.5 9.5L9.5 8.5L12 2Z"
          />
        </svg>
        <p>ویترین ستاره ها</p>
      </div>
      <div class="adsListWrapper">
        <Swiper
          v-if="
            !LoadingSkeleton &&
            $store.state.c_set &&
            $store.state.c_set.shomal_banner_items &&
            $store.state.c_set.shomal_banner_items.length
          "
          class="SnappCarousel"
          :loop="true"
          :slides-per-view="1"
          :dir="'rtl'"
          :modules="modules"
          :autoplay="{
            delay: 4000,
            disableOnInteraction: false,
          }"
          :pagination="{
            dynamicBullets: true,
          }"
        >
          <SwiperSlide
            @click="open_banner(v.link)"
            v-for="(v, i) in $store.state.c_set.main_banner_items"
            :key="i"
          >
            <div class="firstPageAdsWrapper">
              <div class="wrapperPic">
                <img class="SowToUserBoxesSnapp" :src="v.img" alt="banner" />
              </div>
              <div class="wapperCotent">
                <div class="contentTitle">{{ v.title }}</div>
                <div class="contentDesc">
                  {{ v.sub_title }}
                </div>
              </div>
            </div>
          </SwiperSlide>

          <template v-slot:addons>
            <pagination />
          </template>
        </Swiper>
      </div>
      <div
        v-if="!LoadingSkeleton"
        class="desktopFeatures ShowTabToUserCustomer"
      >
        <Swiper
          v-if="!LoadingSkeleton"
          :slides-per-view="showItemNum"
          class="featuresCarousel"
        >
          <SwiperSlide>
            <div
              class="ChildShowTabToUserCustomer1 sliderBottm"
              @click="featureRouteHandler('commission')"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/budget.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">
                  محاسبه کمیسیون
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <a
              href="https://www.kateb.ir/"
              target="_blank"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/auction1.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">سامانه کاتب</p>
              </div>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              href="https://khodnevis.mrud.ir/"
              target="_blank"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/enterprise1.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">
                  سامانه خودنویس
                </p>
              </div>
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <div
              @click="top_users('all')"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/trophy.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">امتیاز برتر</p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide
            v-for="(v, i) in $store.state.c_set.amlak_article_cat"
            :key="i"
          >
            <div
              @click="changeRouteHandler(v.id, v.title)"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img class="featuresThumbImage" :src="v.icon" />
                </div>
                <p class="featuresTitle featuresTitleResponsive">
                  {{ v.title }}
                </p>
              </div>
            </div>
          </SwiperSlide>

          <!-- <SwiperSlide>
          <div class="ChildShowTabToUserCustomer1 sliderBottm">
            <div style="width: 95%; margin: auto">
              <div class="featuresImageWrapper">
                <img class="featuresThumbImage" src="../assets/img/man.png" />
              </div>
              <p class="featuresTitle featuresTitleResponsive">تور 360 درجه</p>
            </div>
          </div>
        </SwiperSlide> -->
        </Swiper>
      </div>

      <div v-if="$store.state.c_set.amlak_banner" class="homeUserAdsBar">
        <img :src="$store.state.c_set.amlak_banner.img" alt="" />
      </div>
      <div v-if="branch_list.length > 0">
        <div class="amlaksListWrapper">
          <div v-if="LoadingSkeleton" class="ShowTitleSiteTemplate titleMt50">
            <Skeletor
              style="
                width: 42px !important;
                background: rgb(146, 221, 238);
                height: 42px;
                border-radius: 50%;
              "
            />
            <Skeletor
              style="
                width: 292px !important;
                background: rgb(146, 221, 238);
                height: 42px;
                border-radius: 24px;
              "
            />
          </div>
          <div v-if="!LoadingSkeleton" class="ShowTitleSiteTemplateWrapper">
            <div class="ShowTitleSiteTemplate">
              <VsxIcon
                iconName="HomeHashtag"
                :size="32"
                color="#0096c7 "
                type="linear"
              />
              <p>دفاتر املاک</p>
            </div>

            <router-link
              to="/amlak-list"
              v-if="!LoadingSkeleton"
              class="LeftTabTextAll"
            >
              <span>همه</span>
              <VsxIcon
                iconName="ArrowLeft2"
                :size="15"
                color="#0096c7"
                type="linear"
              />
            </router-link>
          </div>
          <div class="amlaksList" v-if="LoadingSkeleton">
            <div
              class="amlakThumb"
              v-for="(v, i) in branch_list_limited"
              :key="i"
              @click="all_amklaks(v.id)"
            >
              <div class="thumbPic">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 100%;
                    aspect-ratio: 1;
                    border-radius: 10px;
                  "
                />
              </div>
              <div class="thumbContent" style="min-height: 28px">
                <p :title="v.title"></p>
              </div>
            </div>
          </div>
          <div class="amlaksList" v-if="!LoadingSkeleton">
            <div
              class="amlakThumb"
              v-for="(v, i) in branch_list"
              :key="i"
              @click="all_amklaks(v.id)"
            >
              <div class="thumbPic">
                <img v-lazy :src="v.avatar" :alt="v.title" />
              </div>
              <div class="thumbContent">
                <p :title="v.title">{{ v.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="ShowTabToUserCustomerAdmin">
          <!-- ------------------------------------ -->
          <div
            v-if="LoadingSkeleton && consultant_list.length > 0"
            style="margin-top: 0"
            class="ShowTitleSiteTemplate1"
          >
            <Skeletor
              style="
                width: 42px !important;
                background: rgb(146, 221, 238);
                height: 42px;
                border-radius: 50%;
              "
            />
            <Skeletor
              style="
                width: 292px !important;
                background: rgb(146, 221, 238);
                height: 42px;
                border-radius: 24px;
              "
            />
          </div>
           <div
            v-if="!LoadingSkeleton && consultant_list.length > 0"
            style="margin-top: 0"
            class="ShowTitleSiteTemplate1"
          >
            <VsxIcon
              iconName="Profile2User"
              :size="32"
              color="#0096c7 "
              type="linear"
            />
            <p>مباشران معتبر</p>
          </div>
           <div
            v-if="LoadingSkeleton && consultant_list.length > 0"
            class="home ShowTabToUserCustomer"
          >
            <div class="landStory__container">
              <Swiper :slides-per-view="showItemNum2">
                <SwiperSlide v-for="user in consultant_list" :key="user.name">
                  <div class="UserVForSlider">
                    <Skeletor
                      style="
                        background: rgb(146, 221, 238);
                        display: block;
                        width: 90%;
                        aspect-ratio: 1;
                        border-radius: 50%;
                        margin: 0 auto;
                      "
                    />
                    <p
                      class="featuresTitle featuresTitleResponsive"
                      style="min-height: 28px"
                    ></p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
           <div
            v-if="!LoadingSkeleton && consultant_list.length > 0"
            class="home ShowTabToUserCustomer"
          >
            <div class="landStory__container">
              <Swiper
                :slides-per-view="showItemNum2"
                :modules="modules"
                :autoplay="{ delay: 5000, disableOnInteraction: false }"
                :loop="true"
                ref="consultantSwiper"
                :observer="true"
                :observe-parents="true"
              >
                <SwiperSlide v-for="user in consultant_list" :key="user.name">
                  <div
                    class="UserVForSlider"
                    @click="user_profile(user.uid, 'consultant')"
                  >
                    <img v-lazy :data-src="user.avatar" :alt="user.nickname" />
                    <p class="featuresTitleResponsive">
                      {{ user.lname }}
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div
                v-if="!LoadingSkeleton"
                @click="all_users('consultant')"
                class="LeftTabTextAll topBuildersAll"
              >
                همه
                <VsxIcon
                  iconName="ArrowLeft2"
                  :size="15"
                  color="#0096c7"
                  type="linear"
                />
              </div>
            </div>
          </div>

          <div
            v-if="LoadingSkeleton && valid_branch_list.length > 0"
            class="ShowTitleSiteTemplate1"
          >
            <Skeletor
              style="
                width: 42px !important;
                background: rgb(146, 221, 238);
                height: 42px;
                border-radius: 50%;
              "
            />
            <Skeletor
              style="
                width: 292px !important;
                background: rgb(146, 221, 238);
                height: 42px;
                border-radius: 24px;
              "
            />
          </div>
          <div
            v-if="
              !LoadingSkeleton &&
              valid_branch_list &&
              valid_branch_list.length > 0
            "
            class="ShowTitleSiteTemplate1"
          >
            <VsxIcon
              iconName="Profile2User"
              :size="32"
              color="#0096c7 "
              type="linear"
            />

            <p>مشاوران فعال</p>
          </div>
          <div
            v-if="
              LoadingSkeleton &&
              valid_branch_list &&
              valid_branch_list.length > 0
            "
            class="home ShowTabToUserCustomer"
          >
            <div class="landStory__container">
              <Swiper :slides-per-view="showItemNum2">
                <SwiperSlide v-for="(user, i) in valid_branch_list" :key="i">
                  <div
                    class="UserVForSlider"
                    @click="user_profile(user.uid, 'consultant')"
                  >
                    <Skeletor
                      style="
                        background: rgb(146, 221, 238);
                        display: block;
                        width: 90%;
                        aspect-ratio: 1;
                        border-radius: 50%;
                        margin: 0 auto;
                      "
                    />
                    <p
                      class="featuresTitle featuresTitleResponsive"
                      style="min-height: 28px"
                    ></p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div
            v-if="
              !LoadingSkeleton &&
              valid_branch_list &&
              valid_branch_list.length > 0
            "
            class="home ShowTabToUserCustomer"
          >
            <div class="landStory__container">
              <Swiper
                :slides-per-view="showItemNum2"
                :modules="modules"
                :autoplay="{ delay: 5000, disableOnInteraction: false }"
                :loop="true"
                ref="advisersSwiper"
                :observer="true"
                :observe-parents="true"
              >
                <SwiperSlide v-for="(b, i) in valid_branch_list" :key="i">
                  <div class="UserVForSlider" @click="branch_profile(b.id)">
                    <img v-lazy :data-src="b.avatar" :alt="b.title" />
                    <p class="featuresTitleResponsive">
                      {{ b.title }}
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>
              <div
                v-if="!LoadingSkeleton"
                @click="all_amklak()"
                class="LeftTabTextAll topAdvisersAll"
              >
                <span>همه</span>
                <VsxIcon
                  iconName="ArrowLeft2"
                  :size="15"
                  color="#0096c7"
                  type="linear"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="desktopMain">
      <div class="mainPropertiesList">
        <div class="listTitleWrapper">
          <h2 class="listTitle">آگهی های <span>شمال املاک</span></h2>
          <p class="listSubtitle">
            دسترسی سریع به آگهی‌ های معتبر و بروز حوزه املاک
          </p>
        </div>
      </div>
      <div class="propertiesCatsList">
        <div
          v-if="LoadingSkeleton"
          class="ShowTabToUserCustomer featuresShowTab"
        >
          <div class="featuresCarousel featuresCarouselFlex">
            <div
              v-for="i in 4"
              :key="i"
              class="ChildShowTabToUserCustomer1 sliderBottm"
            >
              <div style="width: 95%; margin: auto">
                <Skeletor
                  style="
                    background: rgb(146, 221, 238);
                    display: block;
                    width: 123.5px;
                    aspect-ratio: 1;
                    border-radius: 10px;
                    margin: 0 auto;
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="ShowTabToUserCustomer featuresShowTab">
          <div class="featuresCarousel featuresCarouselFlex">
            <div
              class="ChildShowTabToUserCustomer1 sliderBottm"
              @click="open_category2('request')"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/document.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">متقاضی</p>
              </div>
            </div>

            <div
              class="ChildShowTabToUserCustomer1 sliderBottm"
              @click="open_category2('fast')"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/lightning-bolt.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">آگهی فوری</p>
              </div>
            </div>

            <div
              class="ChildShowTabToUserCustomer1 sliderBottm"
              @click="open_category2('exchangeable')"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/replace(1).png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">معاوضه</p>
              </div>
            </div>

            <div
              class="ChildShowTabToUserCustomer1 sliderBottm"
              @click="open_category2('student')"
            >
              <div style="width: 95%; margin: auto">
                <div class="featuresImageWrapper">
                  <img
                    class="featuresThumbImage"
                    src="../assets/img/student.png"
                  />
                </div>
                <p class="featuresTitle featuresTitleResponsive">
                  دانشجو / مجرد
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="LoadingSkeleton"
        class="propertyListsContainer homePropertyList"
      >
        <div class="propertyThumb" v-for="i in 16" :key="i">
          <Skeletor
            style="
              background: rgb(146, 221, 238);
              display: block;
              width: 100%;
              aspect-ratio: 8/9;
              border-radius: 12px;
              margin: 0 auto;
            "
          />
        </div>
      </div>
      <div v-else class="propertyListsContainer homePropertyList">
        <div
          class="propertyThumb"
          v-for="(v, i) in post_list"
          :key="i"
          @click="showPost(v)"
        >
          <div class="propertyPic">
            <div class="propertyNums">
              <div class="likesNum">
                <div class="numsICON">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                    />
                  </svg>
                </div>
                <div class="numNumber">{{ v.likes }}</div>
              </div>
              <div class="commentsNum">
                <div class="numsICON">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
                    />
                  </svg>
                </div>
                <div class="numNumber">{{ v.comments_count }}</div>
              </div>
            </div>
            <img :src="v.avatar" :alt="v.content" @error="handleImageError" />
          </div>
          <div class="propertyContent">
            <div class="contanteHeader">
              <div class="propertyCategory">
                {{ v.main_category }}
                <span v-if="v.main_category_en == 'request'">{{
                  v.request_type
                }}</span>
                - {{ v.category }}
              </div>
              <div class="propertyUpload">
                <div class="propertyUploadIcon">
                  <VsxIcon
                    iconName="Calendar"
                    :size="14"
                    color="#0096c7"
                    type="linear"
                  />
                </div>
                <div class="propertyUploadTitle">{{ v.created_fa }}</div>
              </div>
            </div>
            <div class="contentMain">
              <div class="propertyTitle">
                {{
                  v.content.length > 34
                    ? v.content.slice(0, 34) + "..."
                    : v.content
                }}
              </div>
              <div class="propertyLocation">
                <div class="locationIcon">
                  <i class="fa-solid fa-location-dot"></i>
                </div>
                <div class="locationTitle">
                  {{ v.address }}
                </div>
              </div>
              <div class="contentFeaturesWrapper">
                <div
                  v-if="v.feature && v.feature.includes('fast')"
                  class="featuresThumb fast"
                >
                  <i class="fa-solid fa-bolt"></i>
                  <span>فوری</span>
                </div>
                <div
                  v-if="v.feature && v.feature.includes('exchangeable')"
                  class="featuresThumb exchange"
                >
                  <i class="fa-solid fa-rotate"></i>
                  <span>قابل معاوضه</span>
                </div>
                <div
                  v-if="
                    v.feature &&
                    (v.feature.includes('single') ||
                      v.feature.includes('student'))
                  "
                  class="featuresThumb single"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                    />
                    <path
                      d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                    />
                    <path
                      d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                    />
                  </svg>
                  <span>دانشجو/مجرد</span>
                </div>
              </div>
              <div class="contentPriceWrapper">
                <div
                  class="priceWrapper"
                  v-if="
                    v.main_category_en != 'rent' &&
                    !(
                      v.main_category_en == 'request' &&
                      v.request_type_en == 'rent'
                    )
                  "
                >
                  <div class="pricecTitle" v-if="v.main_category_en == 'trade'">
                    قیمت فروش:
                  </div>
                  <div
                    class="pricecTitle"
                    v-if="v.main_category_en == 'request'"
                  >
                    قیمت خرید:
                  </div>
                  <div class="priceValue">{{ v.total_price }}</div>
                </div>
                <div
                  class="priceWrapper"
                  v-if="
                    v.main_category_en == 'rent' ||
                    (v.main_category_en == 'request' &&
                      v.request_type_en == 'rent')
                  "
                >
                  <div class="pricecTitle">مبلغ رهن:</div>
                  <div class="priceValue">{{ v.mortgage_price }}</div>
                </div>
                <div
                  class="priceWrapper"
                  v-if="
                    v.main_category_en == 'rent' ||
                    (v.main_category_en == 'request' &&
                      v.request_type_en == 'rent')
                  "
                >
                  <div class="pricecTitle">مبلغ اجاره:</div>
                  <div class="priceValue">{{ v.rent_price }}</div>
                </div>
              </div>
              <div class="realStateInfoWrapper">
                <div class="realStateInfo">
                  <div class="infoPic">
                    <img :src="v.branch_avatar" alt="" />
                  </div>
                  <div v-if="v.branch_title.trim() != ''" class="infoTitle">
                    {{ v.branch_title }}
                  </div>
                  <div v-else class="infoTitle">{{ v.nickname }}</div>
                </div>
                <div class="realStateBtn">
                  <div class="followBtn">
                    <div class="btnTitle">جزئیات</div>
                    <div class="btnIcon">
                      <i class="fas fa-arrow-left"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainNewsList">
        <div class="newsListTitleWrapper">
          <h2 class="newsTitle">آخرین مطالب <span>شمال املاک</span></h2>
          <p class="newsSubtitle">
            جدیدترین نکات و اخبار دنیای سرمایه‌گذاری ملکی با ما
          </p>
        </div>
        <div class="newsCatsList">
          <div
            v-if="LoadingSkeleton"
            class="ShowTabToUserCustomer featuresShowTab"
          >
            <div class="featuresCarousel featuresCarouselFlex">
              <div
                v-for="i in 6"
                :key="i"
                class="ChildShowTabToUserCustomer1 sliderBottm"
              >
                <div style="width: 95%; margin: auto">
                  <Skeletor
                    style="
                      background: rgb(146, 221, 238);
                      display: block;
                      width: 123.5px;
                      aspect-ratio: 1;
                      border-radius: 10px;
                      margin: 0 auto;
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else class="ShowTabToUserCustomer featuresShowTab">
            <div class="featuresCarousel featuresCarouselFlex">
              <div
                class="ChildShowTabToUserCustomer1 sliderBottm"
                @click="featureRouteHandler('commission')"
              >
                <div style="width: 95%; margin: auto">
                  <div class="featuresImageWrapper">
                    <img
                      class="featuresThumbImage"
                      src="../assets/img/budget.png"
                    />
                  </div>
                  <p class="featuresTitle featuresTitleResponsive">
                    محاسبه کمیسیون
                  </p>
                </div>
              </div>

              <a
                href="https://www.kateb.ir/"
                target="_blank"
                class="ChildShowTabToUserCustomer1 sliderBottm"
              >
                <div style="width: 95%; margin: auto">
                  <div class="featuresImageWrapper">
                    <img
                      class="featuresThumbImage"
                      src="../assets/img/auction1.png"
                    />
                  </div>
                  <p class="featuresTitle featuresTitleResponsive">
                    سامانه کاتب
                  </p>
                </div>
              </a>

              <a
                href="https://khodnevis.mrud.ir/"
                target="_blank"
                class="ChildShowTabToUserCustomer1 sliderBottm"
              >
                <div style="width: 95%; margin: auto">
                  <div class="featuresImageWrapper">
                    <img
                      class="featuresThumbImage"
                      src="../assets/img/enterprise1.png"
                    />
                  </div>
                  <p class="featuresTitle featuresTitleResponsive">
                    سامانه خودنویس
                  </p>
                </div>
              </a>

              <div
                @click="top_users('all')"
                class="ChildShowTabToUserCustomer1 sliderBottm"
              >
                <div style="width: 95%; margin: auto">
                  <div class="featuresImageWrapper">
                    <img
                      class="featuresThumbImage"
                      src="../assets/img/trophy.png"
                    />
                  </div>
                  <p class="featuresTitle featuresTitleResponsive">
                    امتیاز برتر
                  </p>
                </div>
              </div>
              <div
                class="ChildShowTabToUserCustomer1 sliderBottm"
                v-for="(v, i) in $store.state.c_set.amlak_article_cat"
                :key="i"
                @click="changeRouteHandler(v.id, v.title)"
              >
                <div style="width: 95%; margin: auto">
                  <div class="featuresImageWrapper">
                    <img class="featuresThumbImage" :src="v.icon" />
                  </div>
                  <p class="featuresTitle featuresTitleResponsive">
                    {{ v.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsContainer">
          <div class="newsMainColumn">
            <div v-if="LoadingSkeleton" class="newsBigThumb">
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  height: 100%;
                  border-radius: 10px;
                  margin: 0 auto;
                "
              />
            </div>
            <div
              v-else-if="article_list.length > 0"
              class="newsBigThumb"
              @click="articleDetailsHandler(article_list[0].id)"
            >
              <div class="bigThumbBgWrapper">
                <div class="bgPic">
                  <img :src="article_list[0].img" alt="" />
                </div>
                <div class="bgGradient"></div>
              </div>
              <div class="thumbContent">
                <div class="contentTitle">{{ article_list[0].title }}</div>
                <div class="contentDesc" v-html="article_list[0].content"></div>
                <div class="contentDate">{{ article_list[0].created_fa }}</div>
              </div>
            </div>
          </div>
          <div v-if="LoadingSkeleton" class="newsListColumn">
            <div
              class="newsMiniThumb"
              v-for="i in 3"
              :key="i"
              style="padding: 0 !important"
            >
              <Skeletor
                style="
                  background: rgb(146, 221, 238);
                  display: block;
                  width: 100%;
                  height: 116px;
                  border-radius: 10px;
                  margin: 0 auto;
                "
              />
            </div>
          </div>
          <div v-else class="newsListColumn">
            <router-link
              class="newsMiniThumb"
              v-for="(v, i) in article_list.slice(1, 4)"
              :key="i"
              :to="'/news-details?id=' + v.id"
            >
              <div class="thumbPic">
                <img :src="v.img" alt="" />
              </div>
              <div class="thumbContent">
                <div class="contentTitle">{{ v.title }}</div>
                <div class="contentDesc" v-html="v.content"></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from "vue3-toastify";
import axios from "axios";
import { Skeletor } from "vue-skeletor";
import FilterHome from "@/views/FilterHome";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";
import StorySlideWrapper from "@/components/storySlideWrapper/StorySlideWrapper";
export default {
  name: "HomeUser",
  components: {
    Skeletor,
    FilterHome,
    StorySlideWrapper,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      LoadingSkeleton: true,
      showmobhomepage: false,
      showItemNum: 8,
      showItemNum2: 8,
      modules: [Autoplay, Pagination],
      carouselConfig1: {
        itemsToShow: 8,
        wrapAround: false,
        snapAlign: "right",
        dir: "rtl",
        slideSize: "90%",
        paginateByItemsToShow: true,
        autoWidth: false,
      },
      carouselConfig2: {
        itemsToShow: 8,
        wrapAround: false,
        snapAlign: "right",
        slideSize: "90%",
        dir: "rtl",
        autoWidth: false,
      },
      pageWidth: window.innerWidth,
      usersStory: [],
      category_list: [],
      consultant_list: [],
      valid_branch_list: [],
      branch_list: [],
      branch_list_limited: [],
      post_list: [],
      article_list: [],
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      fillter: {
        main_category: "all",
        request_type: "buy",
        category: "all",
        text: "",
        location: "",
        min_width: 0,
        max_width: 0,
        min_price: 0,
        max_price: 0,
        min_rent_price: 0,
        max_rent_price: 0,
        min_mortageprice: 0,
        max_mortageprice: 0,
        bed: -1,
        min_age: 0,
        max_age: 0,
        min_floor: "0",
        max_floor: "0",
        min_totalFloor: "0",
        max_totalFloor: "0",
        min_Floorunit: "0",
        max_Floorunit: "0",
        docType: "0",
        parking: false,
        storage: false,
        elevator: false,
        photo: false,
        newProperty: false,
        special: false,
        fast: false,
        request: false,
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        page: 1,
        per_page: 16,
        single_unit: false,
        two_room: false,
        three_room: false,
        pent: false,
        doblex: false,
        doc_ismelk: false,
        les_sad: false,
        more_sad: false,
        complate_mortage: false,
        rent_mortage: false,
        dayli_rent: false,
        convertable: false,
        iswc: false,
        ispool: false,
        isjacozi: false,
        isglass: false,
        isremotedoor: false,
        iswater: false,
        iselectricity: false,
        isgas: false,
        isceramic: false,
        isbalcony: false,
        rebuild: false,
        inbaft: false,
        outbaft: false,
      },
      isOnline: navigator.onLine,
    };
  },
  watch: {
    isOnline(newVal) {
      if (newVal) {
        this.load_story();
        this.load_category();
        this.load_consultant();
        this.load_valid_branch();
        this.load_branch();
        this.getarticle();
        if (window.innerWidth > 1000) {
          this.load_post();
        }
      }
    },
  },
  methods: {
    resumeAllAutoplay() {
      const tryStart = (swiperRef) => {
        const inst = swiperRef?.swiper;
        if (inst && inst.autoplay) {
          try {
            inst.autoplay.stop();
          } catch (e) {
            console.error("error", e);
          }
          try {
            inst.autoplay.start();
          } catch (e) {
            console.error("error", e);
          }
        }
      };
      tryStart(this.$refs.bannerSwiper);
      tryStart(this.$refs.consultantSwiper);
      tryStart(this.$refs.advisersSwiper);
    },
    handleVisibilityChange() {
      if (!document.hidden) {
        this.resumeAllAutoplay();
      }
    },
    setOnline() {
      this.isOnline = true;
    },
    setOffline() {
      this.isOnline = false;
    },
    featureRouteHandler(type) {
      if (type == "commission") {
        this.$router.push("/commission-calculator");
      } else if (type == "evaluator") {
        this.$router.push("/property-evaluator");
      } else {
        this.$router.push("/complaint");
      }
    },
    calculateItemsToShow() {
      const width = window.innerWidth;
      if (width > 1200) {
        return 8;
      } else if (width > 900) {
        return 6;
      } else if (width > 600) {
        return 4;
      } else {
        return 3.4;
      }
    },
    calculateItemsToShow1() {
      const width = window.innerWidth;
      if (width > 1200) {
        return 8;
      } else if (width > 900) {
        return 6;
      } else if (width > 600) {
        return 5;
      } else {
        return 4.4;
      }
    },
    updateCarouselConfig1() {
      this.pageWidth = window.innerWidth;
      if (this.pageWidth <= 600) {
        this.showmobhomepage = true;
      }
      const itemsToShow = this.calculateItemsToShow();
      const itemsToShow1 = this.calculateItemsToShow1();
      this.carouselConfig1.itemsToShow = itemsToShow;
      this.carouselConfig2.itemsToShow = itemsToShow1;
      this.showItemNum = itemsToShow;
      this.showItemNum2 = itemsToShow1;
    },
    load_story() {
      axios.get(this.$store.getters.baseUrl + "/get-story").then((r) => {
        if (r.data.result == 0) {
          this.usersStory = [];
        } else {
          this.usersStory = r.data.data;
          console.log(r.data.data);
        }
      });
    },
    relaodPage() {
      const checkDocumentReady = () => {
        return new Promise((resolve) => {
          if (document.readyState === "complete") {
            resolve();
          } else {
            window.onload = resolve;
          }
        });
      };

      setTimeout(() => {
        checkDocumentReady().then(() => {
          // LoadingSkeleton.value = false;
        });
      }, 2000);
    },
    load_category() {
      axios.get(this.$store.getters.baseUrl + "/get-category").then((r) => {
        this.category_list = r.data.list;
        console.log(this.category_list);
        this.LoadingSkeleton = false;
      });
    },
    load_consultant() {
      axios
        .post(this.$store.getters.baseUrl + "/user-list", {
          role: "consultant",
          status: "valid_active",
          limit: "8",
        })
        .then((r) => {
          if (r.data.result == 0) {
            this.consultant_list = [];
          } else {
            this.consultant_list = r.data.list;
          }
        });
    },
    load_valid_branch() {
      axios
        .post(this.$store.getters.baseUrl + "/branch-list2", {
          status: "valid_active",
        })
        .then((r) => {
          if (r.data.result == 0) {
            this.valid_branch_list = [];
          } else {
            this.valid_branch_list = r.data.list;
          }
        });
    },
    load_branch() {
      axios.post(this.$store.getters.baseUrl + "/branch-list").then((r) => {
        this.branch_list = r.data.list;
        this.branch_list_limited = r.data.list.slice(0, 9);
        console.log("branch_list", this.branch_list);
      });
    },
    open_category(cat) {
      this.$router.push({ path: "/category", query: { cat } });
    },
    open_category2(feature) {
      this.$router.push({ path: "/category", query: { feature } });
    },
    branch_profile(bid) {
      this.$router.push({ path: "/profile-amlak", query: { bid } });
    },
    changeRouteHandler(id, title) {
      sessionStorage.setItem("prevPage", "homeUser");

      this.$router.push({ path: "/news", query: { id, title } });
    },
    all_amklaks(cid) {
      this.$router.push({ path: "/amlak-list", query: { cid } });
    },
    all_amklak() {
      this.$router.push({ path: "/amlak-list" });
    },
    all_users(role) {
      this.$router.push({ path: "/users-list", query: { role } });
    },
    top_users(role) {
      this.$router.push({ path: "/top-users", query: { role } });
    },
    open_banner(link) {
      if (link) {
        window.open(link, "_blank");
      }
    },
    showPost(ob) {
      localStorage.removeItem("post_detail");
      this.$store.commit("post_detail_set", ob);
      this.$router.push(`/details/${ob.id}`);
    },
    load_post(param) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.fillter.page = 1;
      }
      if (this.$store.state.auth.loggedIn)
        this.fillter.user_id = this.$store.state.auth.uid;

      this.fillter.hastabligh = true;

      axios
        .post(this.$store.getters.baseUrl + "/public-post-list", this.fillter)
        .then((r) => {
          if (r.data.result == 0) {
            this.post_list = [];
            if (param != "first") {
              this.fillter.page -= 1;
            }
          } else {
            this.post_list = this.post_list.concat(r.data.data.list.list);
            if (r.data.data.total_page == this.fillter.page) {
              this.loadmore = false;
            }
          }
          this.isLoading = false;
          this.loadmore_loading = false;
        });
    },
    getarticle() {
      let self = this;
      this.helperPost("get-article", {
        page: 1,
      })
        .then(function (r) {
          const result = r.data;
          if (result.result === "1") {
            self.article_list = self.article_list.concat(result.data.list);
          }
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
        });
    },
    articleDetailsHandler(id) {
      this.$router.push("/news-details?id=" + id);
    },
    complaintRoutheHandler() {
      if (this.$store.state.auth.loggedIn) {
        this.featureRouteHandler("complaint");
      } else {
        this.showLoginAlertHandler();
      }
    },
    showLoginAlertHandler() {
      toast("برای ثبت شکایت وارد حساب کاربری شوید", {
        type: "error",
        dangerouslyHTMLString: true,
      });
      console.log("aljsnavlksno");
    },
    user_profile(uid, role) {
      if (role == "builder") {
        this.$router.push({ path: "/profile-builder", query: { uid } });
      }  else if (role == "consultant") {
        this.$router.push({ path: "/profile-superior", query: { uid } });
      } else {
        this.$router.push({ path: "/profile-amlak", query: { uid } });
      }
    },
  },
  mounted() {
    window.addEventListener("online", this.setOnline);
    window.addEventListener("offline", this.setOffline);
    this.updateCarouselConfig1();
    this.load_story();
    window.addEventListener("resize", this.updateCarouselConfig1);
    this.relaodPage();
    this.load_category();
    this.load_consultant();
    this.load_valid_branch();
    this.load_branch();
    if (window.innerWidth > 1000) {
      this.load_post();
    }
    this.getarticle();
    this.$nextTick(() => {
      const swiper = this.$refs.bannerSwiper?.swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start();
      }
      const consultant = this.$refs.consultantSwiper?.swiper;
      if (consultant && consultant.autoplay) {
        consultant.autoplay.start();
      }
      const advisers = this.$refs.advisersSwiper?.swiper;
      if (advisers && advisers.autoplay) {
        advisers.autoplay.start();
      }
      this.resumeAllAutoplay();
      setTimeout(() => this.resumeAllAutoplay(), 500);
      setTimeout(() => this.resumeAllAutoplay(), 1500);
    });
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    window.addEventListener("focus", this.resumeAllAutoplay);
    document.addEventListener("resume", this.resumeAllAutoplay);
  },
  beforeUnmount() {
    window.removeEventListener("online", this.setOnline);
    window.removeEventListener("offline", this.setOffline);
    window.removeEventListener("resize", this.updateCarouselConfig1);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("focus", this.resumeAllAutoplay);
    document.removeEventListener("resume", this.resumeAllAutoplay);
  },
};
</script>

<style lang="scss" scoped>
.topNav__link {
  color: #0096c7 !important;
}

.categoryListSkeletor {
  width: 70% !important;
}

.searchBarSkeletor {
  width: 36% !important;
}

.searhbarTitleSkeletor {
  border-radius: 24px;
  width: 24% !important;
}

.mobileSnapCaouselSlider {
  display: none;
}

.categoryListSkeletor {
  .ChildShowTabToUserCustomer {
    height: 86px;
  }
}

@media (max-width: 1000px) {
  .categoryListSkeletor {
    width: 95% !important;
    height: 147.6px !important;
    bottom: -37% !important;

    .ChildShowTabToUserCustomer {
      height: 68px;
      margin-bottom: 8px !important;
    }
  }

  .searhbarTitleSkeletor {
    // display: none !important;
    width: 90% !important;
    border-radius: 5px !important;
  }

  .searchBarSkeletor {
    display: none;
  }

  .mobileSnapCaouselSlider {
    display: block;
  }
}

.mainPropertiesList {
  .listTitleWrapper {
    margin-bottom: 32px;

    .listTitle {
      font-family: "iranyekanB", sans-serif;
      font-size: 1.75rem;
      text-align: center;
      margin-bottom: 6px;

      span {
        color: #0096c7;
      }
    }

    .listSubtitle {
      text-align: center;
      font-size: 1rem;
      font-weight: 400;
      opacity: 0.7;
    }
  }
}

@media (min-width: 1000px) {
  .dark {
    .ShowTabToUserCustomer1.categoryList {
      background: #101a23 !important;
      box-shadow: 0 0 10px rgba(255, 255, 255, 0.3) !important;

      .ShowHomeWidthAdnIcon {
        border-color: #2a2a2a !important;
        .ChildShowTabToUserCustomer {
          p {
            color: #fff;
          }
        }
      }
    }

    .mainPropertiesList {
      .listTitleWrapper {
        color: #fff;
      }
    }
    .mainNewsList {
      .newsListTitleWrapper {
        color: #fff;
      }
      .newsContainer {
        .newsMainColumn {
          .newsBigThumb {
            box-shadow: 2px 4px 8px rgba(255, 255, 255, 0.15);
          }
        }
        .newsListColumn {
          .newsMiniThumb {
            background: #101a23;
            color: #fff;
            box-shadow: 2px 4px 8px rgba(255, 255, 255, 0.15);
          }
        }
      }
    }
  }
  .SliderShowToUSerImage {
    height: 632px !important;
  }
  .mobileMain {
    display: none !important;
  }
  .propertiesCatsList {
    width: fit-content;
    margin: -16px auto 24px;

    .featuresCarouselFlex {
      flex-wrap: nowrap;
    }

    .ShowTabToUserCustomer {
      margin: 0 !important;
      width: fit-content;

      .ChildShowTabToUserCustomer1 {
        margin: 0 6px !important;

        p {
          font-size: 0.8rem !important;
        }
      }
    }
  }
  .propertyListsContainer {
    &.homePropertyList {
      width: 90% !important;
      margin: 0 auto !important;
      grid-template-columns: repeat(4, 1fr) !important;
      gap: 32px;

      .propertyThumb {
        margin: 0 !important;
      }
    }
  }
  .mainNewsList {
    padding-top: 54px;
    padding-bottom: 48px;
    .newsListTitleWrapper {
      margin-bottom: 42px;

      .newsTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.75rem;
        text-align: center;
        margin-bottom: 6px;

        span {
          color: #0096c7;
        }
      }

      .newsSubtitle {
        text-align: center;
        font-size: 1rem;
        font-weight: 400;
        opacity: 0.7;
      }
    }

    .newsCatsList {
      width: fit-content;
      margin: -16px auto 24px;

      .featuresCarouselFlex {
        flex-wrap: nowrap;
      }

      .ShowTabToUserCustomer {
        margin: 0 !important;
        width: fit-content;

        .ChildShowTabToUserCustomer1 {
          margin: 0 6px !important;

          p {
            font-size: 0.8rem !important;
          }
        }
      }
    }
    .newsContainer {
      width: 90%;
      margin: 0 auto;
      display: grid;
      grid-template-columns: calc(60% - 16px) calc(40% - 16px);
      justify-content: space-between;
      align-items: center;

      .newsMainColumn {
        width: 100%;

        .newsBigThumb {
          position: relative;
          width: 100%;
          height: 412px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.15);
          &:hover {
            .bigThumbBgWrapper {
              .bgPic {
                img {
                  transform: scale(1.05);
                }
              }
            }
          }
          .bigThumbBgWrapper {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;

            .bgPic {
              width: 100%;
              height: 100%;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: all 0.2s;
              }
            }

            .bgGradient {
              position: absolute;
              z-index: 1;
              inset: 0;
              width: 100%;
              height: 100%;
              background: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.7),
                rgba(0, 0, 0, 0)
              );
            }
          }

          .thumbContent {
            position: relative;
            max-width: 620px;
            width: 100%;
            height: 100%;
            padding: 24px;
            display: flex;
            flex-direction: column;
            justify-content: end;
            align-items: flex-start;
            z-index: 2;

            .contentTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 1.35rem;
              margin-bottom: 12px;
              color: #fff;
              text-align: justify;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .contentDesc {
              font-size: 0.95rem;
              color: #fff;
              line-height: 24px;
              text-align: justify;
              margin-bottom: 24px;
              text-align: justify;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
              overflow: hidden;
              line-height: 24px;

              :deep(p) {
                line-height: 24px;
              }
            }

            .contentDate {
              position: relative;
              padding-right: 14px;
              font-size: 0.75rem;
              color: #fff;
              opacity: 0.75;

              &::before {
                content: "";
                display: block;
                width: 8px;
                height: 2px;
                background: #fff;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
      }

      .newsListColumn {
        width: 100%;

        .newsMiniThumb {
          width: 100%;
          padding: 12px;
          background: #fff;
          box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.15);
          border-radius: 12px;
          display: flex;
          align-items: center;
          gap: 16px;

          &:not(:last-of-type) {
            margin-bottom: 24px;
          }

          .thumbPic {
            flex-shrink: 0;
            img {
              width: 92px;
              height: 92px;
              object-fit: cover;
              border-radius: 12px;
            }
          }

          .thumbContent {
            padding-left: 16px;
            .contentTitle {
              font-family: "iranyekanB", sans-serif;
              font-size: 1.05rem;
              margin-bottom: 4px;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .contentDesc {
              font-size: 0.85rem;
              line-height: 20px;
              opacity: 0.85;
              text-align: justify;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              :deep(p),
              :deep(strong) {
                font-family: "iranyekan", sans-serif !important;
                font-size: 0.85rem !important;
                line-height: 20px !important;
                font-weight: 400 !important;
              }
            }
          }
        }
      }
    }
  }

  .ShowTabToUserCustomer1 {
    &.categoryList {
      grid-template-columns: repeat(8, 1fr) !important;
      justify-content: space-between !important;
      gap: 20px !important;
      bottom: -64px !important;
      right: 0 !important;
      left: 0 !important;
      margin: auto !important;
      background: #fff !important;
      width: 70% !important;
      height: 126px !important;
      overflow: hidden !important;
      border-radius: 8px !important;
      align-items: center !important;
      padding: 14px !important;
      box-shadow: 0 0.125rem 1.5rem 0 rgba(14, 16, 17, 0.08) !important;

      .ShowHomeWidthAdnIcon {
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        border: 1px solid #f5f5f5 !important;
        border-radius: 8px !important;

        .ChildShowTabToUserCustomer {
          width: 100% !important;
          height: 100% !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;

          p {
            position: relative;
            z-index: 2;
            color: #000;
            font-size: 0.85rem;
            font-family: "iranyekanB";
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .desktopMain {
    display: none !important;
  }
}

.dark {
  .firstPageAdsWrapper {
    background: #101a23;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.15);

    .wapperCotent {
      .contentTitle {
        color: #fff;
      }

      .contentDesc {
        color: #ccc;
      }
    }
  }
}

.firstPageAdsWrapper {
  width: 95%;
  height: 220px;
  margin: auto;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);

  .wrapperPic {
    width: 100%;
    height: 150px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0 !important;
    }
  }

  .wapperCotent {
    height: calc(100% - 150px) !important;
    padding: 4px 18px 0 !important;

    .contentTitle {
      color: #333;
      white-space: nowrap;
      font-size: 0.9rem;
      font-family: "iranyekanB";
    }

    .contentDesc {
      font-family: "iranyekan", sans-serif;
      /* font-weight: 500; */
      font-size: 0.75rem;
      white-space: wrap;
      line-height: 0.9rem;
      color: #333;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.SnappCarousel {
  padding-bottom: 8px;
}
</style>
